import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

export default function Nav() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <nav className="nav">
      <Link to="/" className="nav-logo" onClick={close}>
        <img src="/images/logo-zahra.jpg" alt="Zahra's Learning" className="nav-logo-img" />
        zahra<span>'s</span> learning
      </Link>
      <ul className={`nav-links ${open ? 'open' : ''}`}>
        <li><NavLink to="/articles" onClick={close}>Articles</NavLink></li>
        <li><NavLink to="/notes" onClick={close}>Notes</NavLink></li>
        <li><NavLink to="/cards" onClick={close}>Cards</NavLink></li>
        <li><NavLink to="/qcm" onClick={close}>QCM</NavLink></li>
        <li><NavLink to="/plans" onClick={close}>Plans</NavLink></li>
        <li><NavLink to="/about" onClick={close}>À propos</NavLink></li>
        <li><NavLink to="/cv" onClick={close}>CV</NavLink></li>
      </ul>
      <div className="nav-actions">
        <ThemeToggle />
        <button className="nav-toggle" onClick={() => setOpen(o => !o)} aria-expanded={open}>Menu</button>
      </div>
    </nav>
  );
}
